import React, { useEffect, useRef, useState } from 'react'
import { Anchor, Box, Button, Text, TextInput } from '@mantine/core'
import { IconShieldCheck } from '@tabler/icons-react'
import useVerificationCodeTimer from '../../hooks/useVerificationCodeTimer'

interface VerificationCodeInputProps {
  value: string
  onChange: (value: string) => void
  error?: React.ReactNode
  phone: string
  onValidatePhone: () => { hasError: boolean }
  onSwitchToFaceid?: () => void
}

export default function VerificationCodeInput({
  value,
  onChange,
  error,
  phone,
  onValidatePhone,
  onSwitchToFaceid,
}: VerificationCodeInputProps) {
  const { label, startTimer, isActive } = useVerificationCodeTimer()
  const [showFaceidHint, setShowFaceidHint] = useState(false)
  const callbackRef = useRef(onSwitchToFaceid)

  useEffect(() => {
    callbackRef.current = onSwitchToFaceid
  }, [onSwitchToFaceid])

  useEffect(() => {
    if (isActive && callbackRef.current) {
      const timer = setTimeout(() => {
        setShowFaceidHint(true)
      }, 10000)
      return () => clearTimeout(timer)
    } else {
      setShowFaceidHint(false)
    }
  }, [isActive])

  const handleSendCode = () => {
    const result = onValidatePhone()
    if (result.hasError) {
      return
    }
    startTimer({ phone: phone, type: 6 })
  }

  return (
    <>
      <TextInput
        mt="md"
        placeholder="请输入验证码"
        maxLength={6}
        leftSection={<IconShieldCheck size={16} />}
        rightSectionWidth={94}
        rightSection={
          <Button size="xs" variant="subtle" onClick={handleSendCode} disabled={isActive}>
            {label}
          </Button>
        }
        value={value}
        onChange={(event) => onChange(event.currentTarget.value)}
        error={error}
      />
      {showFaceidHint && (
        <Box
          mt="xs"
          p="xs"
          style={{
            backgroundColor: '#F0F7FF',
            borderRadius: '8px',
            border: '1px solid #E3F2FD',
          }}
        >
          <Text size="sm" c="dimmed">
            💡 收不到验证码？试试{' '}
            <Anchor onClick={() => callbackRef.current?.()} style={{ cursor: 'pointer', fontWeight: 500 }}>
              人脸识别验证 →
            </Anchor>
          </Text>
        </Box>
      )}
    </>
  )
}
